import { RadioGroup } from '@headlessui/react'
import classNames from 'classnames'
import { Dispatch, Key, SetStateAction } from 'react'
import { twMerge } from 'tailwind-merge'

interface TimeRadioProps {
	sessionsDates: Array<{
		day: string
		hours: string[]
	}>
	selectedDate: string
	className?: string
	setSelectedTime?: Dispatch<SetStateAction<string>>
}

export default function TimeRadio({
	sessionsDates,
	selectedDate,
	setSelectedTime,
}: TimeRadioProps) {
	const timesData = sessionsDates?.findIndex(
		({ day }: { day: string }) => day === selectedDate
	)

	const sessions = sessionsDates && sessionsDates[timesData].hours

	return (
		<RadioGroup
			onChange={setSelectedTime}
			className='flex gap-3 gap-y-4 flex-wrap'
		>
			{sessions?.map((plan: string, key: Key | null | undefined) => (
				<RadioGroup.Option
					key={key}
					value={plan}
					className={({ active, checked }) =>
						twMerge(
							'relative flex min-w-[65px] h-[32px] bg-white dark:bg-[#20162D] text-sm text-white leading-5 cursor-pointer rounded-lg items-center justify-center focus:outline-none',
							classNames({
								'bg-brand-primary/15 dark:bg-brand-primary dark:text-[#F7F9FB] dark:font-semibold': active || checked,
							})
						)
					}
				>
					{plan}
				</RadioGroup.Option>
			))}
		</RadioGroup>
	)
}
